export const GAS_UNITS = [
  'usd',
  'gwei',
  'rao',
] as const;

export type GasUnit = typeof GAS_UNITS[number];
